
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PortfolioHeader from '../portfolio/components/Header';



const PortfolioDetails = ({ selectedProject, onClose }) => {
    const location = useLocation();
    const { props } = location.state;
    console.log(props);

    const [open, setOpen] = React.useState(false);

    console.log(props.data);
    const projectData = props.data;
    const projectScreenshots = [projectData.project_pilot_screenshots, projectData.project_full_screenshots];
    console.log(projectScreenshots);
    useEffect(() => {

        console.log(document.getElementById('closeBtn'));
    }, [])

    return (
        <>
            <PortfolioHeader />
            <div className="gearsBg">
                <div className="wheel8"></div>
                <div className="wheel9"></div>
                <div className="wheel10"></div>
                <ul className="innerTopNav">
                    <li><Link to="/portfolio/frontend"><span>Front-end Stack</span></Link></li>
                    <li><Link to="/portfolio/uiux"><span>UI/UX</span></Link></li>
                    <li><Link to="/portfolio/middleware" className="active"><span>Middleware</span></Link></li>
                    <li><Link to="/portfolio/digitalmarketing" ><span>Digital Marketing</span></Link></li>
                </ul>
            </div>
            <div className="paper">
                <div className="top">&nbsp;</div>
                <div className="mid clearfix">
                    {/* <div className="flex-row-container">
                        <div className="flex-item modal-title"><Link to="/portfolio/uiux"><span className="mdi mdi-chevron-left"></span></Link> {projectData.project_title}  </div>
                       
                    </div> */}
                    <div className="flex-row-container">
                        <div className="flex-item" style={{width: "250px"}}>
                        <Link to="/portfolio/uiux" className="txt-20 thicker"><span className="mdi mdi-chevron-left"></span> Back</Link> <br /><br />
                            <img src={projectData.project_pilot_screenshots[0]} width="90%" />
                        </div>
                        <div className="flex-2 ">
                        <div className=" modal-title">{projectData.project_title}  </div> 
                            <p>{projectData.project_short_desc}</p><br />
                            {
                                projectData.project_type.map((item) => {
                                    return <span className="chip">{item} </span>
                                })
                            }
                            <div className="flex-row-container ">
                                {projectScreenshots[0].map((file, index) => {
                                    return (
                                        <div className='card flex-item-4 link'>
                                            <a href={`${projectScreenshots[1][index]}`} data-lightbox="roadtrip">
                                            <img src={`${projectScreenshots[0][index]}`}  width='100%' />
                                            </a>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div id="image-preview" className="image-preview">

                        </div>
                    </div>
                </div>
                <div className="btm">&nbsp;</div>
            </div>
        </>
    )
}
export default PortfolioDetails;

